module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/img (56).e4d536d7.jpg";